<template>
    <div
        class="w-[36px] h-[22px] rounded-lg cursor-pointer relative transition-colors duration-200 ease-in-out"
        :class="[checked ? checkedClass : 'bg-grey-700', disabled ? 'bg-white/30' : '']"
        :disabled="disabled"
    >
        <input type="checkbox" :checked="checked" @click="$emit('toggle')" class="absolute inset-0 appearance-none cursor-pointer z-10" :disabled="disabled" />

        <div
            class="rounded-full bg-white dark:bg-grey-300 w-4.5 h-4.5 absolute top-0.5 left-0.5 cursor-pointer transition-transform duration-200 ease-in-out"
            :class="{
                'translate-x-[14px]': checked,
                '!bg-grey-900': disabled,
            }"
        />
    </div>
</template>

<script>
export default {
    props: {
        checked: {
            type: Boolean,
            default: false,
        },
        checkedClass: {
            type: String,
            default: 'bg-black dark:bg-grey-900',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },

    methods: {
        setChecked() {
            // console.log('setChecked')
            // this.$emit('change', !this.checked)
        },
    },
}
</script>
